export default __webpack_public_path__ + "static/media/material-recycle.478008b5.png";